export const buildOrderFormLink = (productId, mediatorId, feedbackType = null) => {
  if (!productId || !mediatorId) return '';

  const params = new URLSearchParams({
    productId: String(productId),
    mediatorId: String(mediatorId),
  });

  if (feedbackType) {
    params.set('feedbackType', feedbackType);
  }

  const base = typeof window !== 'undefined' ? window.location.origin : '';
  return `${base}/order?${params.toString()}`;
};

export const buildRefundFormLink = () => {
  const base = typeof window !== 'undefined' ? window.location.origin : '';
  return `${base}/refund`;
};

export const buildTermsLink = () => {
  const base = typeof window !== 'undefined' ? window.location.origin : '';
  return `${base}/guides`;
};

export const copyOrderFormLink = async (productId, mediatorId, feedbackType = null) => {
  const link = buildOrderFormLink(productId, mediatorId, feedbackType);
  if (!link) {
    throw new Error('Missing product or mediator');
  }
  await navigator.clipboard.writeText(link);
  return link;
};
